export enum EmailImagePositionEnum {
    HEADER = 'HEADER',
    FOOTER = 'FOOTER'
}
